import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {ProjectActivityService} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {ActivityType} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/activity-type';
import {LocalStorage} from 'ngx-webstorage';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {User} from 'projects/core/src/lib/login/data/user';

@Component({
  selector: 'app-types-filter',
  templateUrl: './types-filter.component.html',
  styleUrls: ['./types-filter.component.scss']
})
export class TypesFilterComponent implements OnInit {

  @Output() filterChange = new EventEmitter<number[]>();

  types: ActivityType[] = [];

  @LocalStorage()
  selectedTypeIds: number[];

  currentUser: User;

  constructor(
    protected projectActivityService: ProjectActivityService,
    protected appStateQuery: AppStateQuery
  ) {
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(currentUser => this.currentUser = currentUser);
    this.getActivityTypes();
  }

  getActivityTypes() {
    this.projectActivityService.getActivityTypes()
      .subscribe(types => {
        this.types = types;

        if (this.currentUser.installationUser) {
          this.types = this.types.filter(type => type.name === 'Installation');
          this.selectedTypeIds = null;
        }

        if (typeof this.selectedTypeIds === 'undefined' || this.selectedTypeIds === null) {
          this.selectedTypeIds = this.types.map(type => type.id);
        }

        this.filterChange.emit(this.selectedTypeIds);
      });
  }

  onFilterChange() {
    this.filterChange.emit(this.selectedTypeIds);
  }
}

